/**
 * secure-score-severity.ts — promoted from SecurityCenter.tsx so the new
 * Secure Score recommendations queue can reuse the same severity heuristic
 * as the Overview tab.
 *
 * Microsoft doesn't ship a SHALL/SHOULD/MAY equivalent for Secure Score, so
 * we derive severity from absolute point gap (the strongest signal we have)
 * with a Microsoft-flag bump when rank is in the top 3.
 */

export type SecureScoreSeverity = 'crit' | 'high' | 'med'

export function severityFromSecureScoreRank(
  rank: number | undefined,
  gap: number,
): SecureScoreSeverity {
  if (gap >= 5) return 'crit'
  if (gap >= 3) return 'high'
  // Rank 1-3 are Microsoft-flagged "highest impact" — promote them even if
  // the pt gap is small (e.g. partially-implemented).
  if (rank != null && rank <= 3) return 'high'
  return 'med'
}
